<template>
    <div>
        <v-dialog v-model="dialog" max-width="600px">
            <v-card>
            <v-form ref="form" @submit.prevent="editRider">
                <v-card-title>
                <span class="headline">{{ $t("riders.edit_rider") }}</span>
                </v-card-title>
                <v-card-text>
                <v-row no-gutters class="mt-2">
                    <v-col md="6" class="pb-0 pr-1">
                    <v-text-field
                        v-model="form.fName"
                        :label="$t('riders.first_name')"
                        disabled
                        outlined dense
                    ></v-text-field>
                    </v-col>
                    <v-col md="6" class="pb-0 pt-0">
                    <v-text-field
                        v-model="form.lName"
                        :label="$t('riders.last_name')"
                        disabled outlined dense
                    ></v-text-field>
                    </v-col>
                    <v-col md="12" class="pb-0 pt-0">
                      <v-select 
                        outlined dense
                        v-model="form.relationship"
                        :label="$t('riders.relationship')"
                        :items="itemsRelationshipOptions"
                        :no-data-text="$t('common.no_data')"
                      ></v-select>
                    </v-col>
                </v-row>
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn 
                    @click="close"
                    :color="`${buttonColor}`"
                    class="btn mb-2"
                    >{{ $t("riders.cancel") }}</v-btn>
                <v-btn
                    type="submit"
                    :color="`${buttonColor}`"
                    class="btn mb-2"
                >{{ $t("riders.save") }}</v-btn>
                </v-card-actions>
            </v-form>
            </v-card>
        </v-dialog>
        <v-col md="12" class="text-right pt-0 pb-0" >
            <v-btn :color="`${buttonColor}`" dark class="mb-2" @click="addPart">
            {{ $t("authorization.add_rider")}}
            </v-btn>
        </v-col>
        <v-col md="12" class="pt-0">
            <v-data-table
              :headers="ridersHeaders"
              :items="myAccManItems"
              class="elevation-1"          
              dense
              :footer-props="{
                'items-per-page-text': $t('dataTable.rowsPerPageText'),
                'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
              }"
              :no-data-text="$t('dataTable.noDataText')"
              :headerProps="{
                'sort-by-text': $t('dataTable.sortByText')
              }"
            >
            <template v-slot:top>     
                <v-dialog v-model="dialogDelete" max-width="600px">
                    <v-card>
                        <v-card-title class="headline">{{ $t('authorization.delete_rider') }}</v-card-title>
                        <v-card-text>
                        <p class="mt16">{{ $t('authorization.sure_delete') }}</p>
                        </v-card-text>
                        <v-card-actions>
                        <v-btn class="btn mb-2 mr-2" :color="`${buttonColor}`" @click="closeDelete('ri')">{{ $t('riders.cancel') }}</v-btn>
                        <v-btn
                            :color="`${buttonColor}`"
                            class="btn mb-2"
                            @click="deleteItemConfirm('ri')"
                            >{{ $t('riders.delete') }}</v-btn>
                        <v-spacer></v-spacer>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </template>
            <template v-slot:[`item.relationship`]="{ item }">
              {{ $te("relationship."+(item.relationship || '').toLowerCase()) ? $t("relationship."+(item.relationship || '').toLowerCase()) : item.relationship }}
            </template>
            <template v-slot:[`item.status`]="">
              {{ $t("authorization.status") }}
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <v-icon v-if="item.isEdit" small class="mr-2" @click="editItem(item, 'ri')">fa far fa-pencil-alt</v-icon>
                <v-icon v-if="item.isEdit" small @click="deleteItem(item, 'ri')">fa far fa-trash-alt</v-icon>
            </template>
            </v-data-table>
        </v-col>
        <Snack :snack="snackbar" :snackMsg="msg_snackbar" :snackCol="color_snackbar"/>
    </div>
</template>

<script>
import Snack from "@/components/notifications/Snack";
import RelationshipService from "../../services/RelationshipService";
import { VCol, VDataTable, VDialog, VCard, VSpacer, VIcon, VBtn,
         VCardTitle, VCardText, VCardActions, VForm, VRow, VTextField, VSelect } from 'vuetify/lib';

export default {
  components: {
    Snack,
    VCol, VDataTable, VDialog, VCard, VSpacer, VIcon, VBtn,
    VCardTitle, VCardText, VCardActions, VForm, VRow, VTextField, VSelect 
  },
  data() {
    const ridersForm = Object.freeze({
      firstName: "",
      lastName: "",
      relationShip: ""
    });
    return {
      msg_snackbar: '',
      color_snackbar: '',
      snackbar: false,
      buttonColor: "#000",
      dialog: false,
      editedIndex: -1,
      dialogDelete: false,
      ridersForm,
      form: Object.assign({}, ridersForm),
      itemsRelationship: [],      
      myAccManItems: [],
      defaultItem: {
        firstName: "",
        lastName: "",
        relationShip: ""
      },
      userRoleId: 2,
      userRolePartId: 1,
      borderAlertColor: "#1234",
      bgAlertColor: "",
      iconAlertColor: "",
      yourAccManItems: [],
      dialogDeleteAM: false
    };
  },
  computed: {
    ridersHeaders(){
      return [
        {
          text: this.$t("authorization.livelaps_id"),
          align: "",
          sortable: true,
          value: "userId"
        },
        { text: this.$t("riders.email"), value: "email" },
        {
          text: this.$t("riders.first_name"),
          align: "",
          sortable: false,
          value: "fName"
        },
        { text: this.$t("riders.last_name"), value: "lName" },
        { text: this.$t("riders.relationship"), value: "relationship" },
        { text: this.$t("authorization.auth"), value: "status" },
        {
          text: this.$t("riders.actions"),
          value: "actions",
          sortable: false
        }
      ]
    },
    itemsRelationshipOptions(){
      return this.itemsRelationship.map((el) => {
        const normalizedRelationship = String(el || "").trim().toLowerCase();
        const relationshipKey = `relationship.${normalizedRelationship}`;
        return {
          text: this.$te(relationshipKey) ? this.$t(relationshipKey) : el,
          value: el
        }
      }).sort((a, b) => a.text.localeCompare(b.text));
    }
  },
  methods: {
    addPart(){
      this.$router.push({
        path: "createAuthorization"
      }); 
    },
    itemsRelationship_(){
      RelationshipService.showRelationshipValues().then(response => {
        if(response.data.success == 1){
          this.itemsRelationship = response.data.message;
        }
      });
    },
    async showLinkedMembers(){
      let myAccMan = [];
      await RelationshipService.getMyAccountManager().then(response => {
        if(response.data.success == 1){
          myAccMan = response.data.message;
        }
      });
      myAccMan.forEach(element => {
        element.isEdit = true;
        //element.status = this.$t("authorization.status")
        this.myAccManItems.push(element);
      });
      let yourAccMan = [];
      await RelationshipService.getYourAccountManager().then(response =>{
        if(response.data.success == 1){
          yourAccMan = response.data.message;
        }
      })
      yourAccMan.forEach(element => {
        element.isEdit = true;
        element.status = this.$t("authorization.status_am")
        this.yourAccManItems.push(element);
      });
    },
    editItem(item, _dt) {
      this.editedIndex = _dt == 'am' ? this.managerPartItems.indexOf(item) : this.myAccManItems.indexOf(item);      
      this.form = Object.assign({}, item);
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.form = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    closeDelete(_dt) {
      _dt == 'am' ? this.dialogDeleteAM = false : this.dialogDelete = false;
      this.$nextTick(() => {
        this.form = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    editRider() {
      let data = {};

      data.relId = this.form.linkedMemberId;
      data.relType = this.form.relationship;
      RelationshipService.relationshipUpdate(data).then(response => {

        if(response.data.success == 1){
          this.dialog = false;
          //this.ridersItems = [];
          this.myAccManItems = [];
          this.managerPartItems = [];
          this.showSnackBar(this.$t("riders.msg_success_edited"), "success");
          this.showLinkedMembers();
        }

      });
     
    },
    showSnackBar(msg, color){
      this.snackbar = true;
      this.msg_snackbar = msg;
      this.color_snackbar = color;
      setTimeout(() => this.snackbar = false, 3000);
    },
    deleteItem(item, _dt) {
      this.editedIndex = _dt == 'am' ? this.yourAccManItems.indexOf(item) : this.myAccManItems.indexOf(item);
      this.form = Object.assign({}, item);
      _dt == 'am' ? this.dialogDeleteAM = true : this.dialogDelete = true;
    },
    deleteItemConfirm(_dt) {
      _dt == 'am' ? this.yourAccManItems.splice(this.editedIndex, 1) : this.myAccManItems.splice(this.editedIndex, 1);
      this.closeDelete(_dt);
      RelationshipService.relationshipDelete(this.form.linkedMemberId).then(response => {

        if(response.data.success == 1){
          this.myAccManItems = [];
          this.yourAccManItems = [];
          this.showSnackBar(this.$t("riders.msg_success_deleted"), "success");
          this.showLinkedMembers();
        }

      });
    }
  },
  created(){
    this.buttonColor = this.$store.getters.env.get('VUE_APP_BUTTON_COLOR');
    this.borderAlertColor = this.$store.getters.env.get('VUE_APP_BORDER_ALERT_REGULAR');    
    this.iconAlertColor = this.$store.getters.env.get('VUE_APP_ICON_ALERT_REGULAR');    
    this.bgAlertColor = this.$store.getters.env.get('VUE_APP_BG_ALERT_REGULAR');   
    this.showLinkedMembers();
    this.itemsRelationship_();
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    }
  }
}
</script>

<style>
.authorization .v-data-table-header,
.authorization .v-card__title {
  background: #ccc;
}
.mt16 {
  margin-top: 16px;
}
.btn{
  color:#fff !important;
}
.v-card__actions{
  display: inherit;
  text-align: right;
}
</style>